const TOKEN_KEY = 'rstrlp.report.token';
const FINGERPRINT_KEY = 'rstrlp.report.fingerprint';

export interface UnlockResult { token: string; quotaLeft: number; message: string; }

export async function unlockReport(code: string, fingerprint: string): Promise<UnlockResult> {
  const response = await fetch('/api/unlock', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ code, fingerprint }),
  });
  const data = await response.json().catch(() => ({})) as Partial<UnlockResult> & { success?: boolean };
  if (!response.ok || !data.success || !data.token) throw new Error(data.message || '激活失败，请稍后重试');
  localStorage.setItem(TOKEN_KEY, data.token);
  localStorage.setItem(FINGERPRINT_KEY, fingerprint);
  return { token: data.token, quotaLeft: data.quotaLeft ?? 0, message: data.message || '完整报告已解锁' };
}

export async function hasUnlocked(fingerprint: string): Promise<boolean> {
  const token = localStorage.getItem(TOKEN_KEY);
  if (!token || localStorage.getItem(FINGERPRINT_KEY) !== fingerprint) return false;
  const response = await fetch(`/api/session?fingerprint=${encodeURIComponent(fingerprint)}`, {
    headers: { Authorization: `Bearer ${token}` },
  }).catch(() => null);
  return Boolean(response?.ok);
}
